import { AxiosResponse, CancelToken } from "axios";
import http from "../../../shared/http";
import { SettingsRequestDto, SettingsResponseDto } from "./dtos";
import { qs } from "../../../utils";

export const settings = async (
  { _query }: SettingsRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<SettingsResponseDto>> => {
  const query = qs.stringify(_query);
  return await http.get<SettingsResponseDto>(`/settings${query}`, {
    cancelToken,
  });
};
